function getLang(): string {
  // @ts-ignore
  return (( window.$nuxt || {}).$LanguageService || {}).currentLanguage || 'en';
}

export default function formatNumber(number: number, options = {}) {
  return new Intl.NumberFormat(getLang(), {...options }).format(number);
}

export function formatCurrency(number: number, currency = 'EUR', options = {}) {
  return formatNumber(number, {...options, style: 'currency', currency });
}
